export default __webpack_public_path__ + "static/media/car-right-side.63808c37.svg";